import { RefObject, useEffect } from "react"

type AnyEvent = MouseEvent | TouchEvent

export function useClickOutside<T extends HTMLElement>(ref: RefObject<T>, handler: (event: AnyEvent) => void, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return

    const listener = (event: AnyEvent) => {
      const el = ref.current
      if (!el) return

      if (el.contains(event.target as Node)) return

      handler(event)
    }

    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)

    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
    }
  }, [ref, handler, enabled])
}
